import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCircleCheckSolid = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m3.973-10.652-4.5 4.5a.84.84 0 0 1-1.192 0l-2.25-2.25a.843.843 0 0 1 1.192-1.192l1.652 1.652 3.902-3.906a.843.843 0 0 1 1.192 1.192z"
    }));
export default SvgCircleCheckSolid;
